import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/livesheet/")({
  beforeLoad: () => {
    throw redirect({ to: "/livesheet/resultados" });
  },
});
